import { createFileRoute } from "@tanstack/react-router";
import { StreamContent } from "@/features/study-group-stream/components/StreamContent";
import { FeedInputProvider } from "@/features/study-group-stream/contexts/FeedInputContext";

const StreamRoute = () => (
  <FeedInputProvider>
    <StreamContent />
  </FeedInputProvider>
);

export const Route = createFileRoute("/study-group/$study-group-id/stream")({
  component: StreamRoute,
});
